export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Planificateur médias sociaux',
        blog: 'Blogue',
        funnel: 'Tunnel',
        website: 'Site Web',
        email: 'Courriel',
        words: 'Mots',
        variations: 'Variantes',
    },
};
